var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObolSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 500 500",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M454.057 259.054C452.396 325.833 427.875 389.285 364.975 432.511C250.955 511.066 92.0457 448.583 60.8736 313.504C45.2182 245.617 51.4519 180.363 91.3513 121.759C136.102 56.0915 200.801 29.4899 278.523 38.356C355.001 47.0833 407.229 90.7261 437.154 161.245C449.347 190.198 453.782 220.54 454.057 259.054ZM432.445 247.694C431.337 237.443 430.643 223.034 428.288 208.764C426.489 197.821 423.162 187.153 419.561 176.623C375.366 49.4411 213.41 15.0811 124.603 116.078C66.2773 182.44 60.7347 260.995 94.5392 340.519C137.071 440.547 260.238 476.151 350.15 415.748C407.923 377.234 430.368 319.46 432.445 247.694Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.092 430.848C51.4519 390.948 14.0461 333.452 12.9382 254.761C11.8303 173.435 49.0972 113.723 117.675 72.0216C63.506 119.682 36.9043 179.669 36.9043 251.574C37.0432 323.617 63.7838 383.468 118.092 430.848Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M388.25 430.57C499.637 341.905 496.591 158.752 388.666 72.8549C437.988 93.4974 492.157 163.6 494.789 243.399C498.116 339.547 436.324 409.789 388.25 430.57Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.909 278.866L302.909 224.836L256.081 197.682L209.115 224.836L209.115 278.866L256.081 306.021L302.909 278.866Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObolSimple);
export default __webpack_public_path__ + "static/media/obol_simple.fd415592787a989762cf2e05d6eb01aa.svg";
export { ForwardRef as ReactComponent };